import { DataVehicles, normalizeVouchers, PersonBenefits, VouchersCampaign } from '@esportal/portal-service';
import {
	HuchaDisclaimer1Text,
	HuchaDisclaimer2Plus15Text,
	HuchaDisclaimer2S10To15Text,
} from '../../components/benefits/bonos/hucha-venta/components/disclaimers/hucha-disclaimers';
import { getHuchaTierFromDiscounts } from '../../components/benefits/bonos/hucha-venta/helpers/get-renovador-tier';
import { NamedDisclaimer } from './disclaimers-utils';
import { noVehicleOrder2025, voucherAlertExists } from '../alert-utils';
import { IdWeChargeDisclaimerText } from '../../components/alerts/data/alerts-disclaimers';
import { BonoDisclaimerText } from '../../components/benefits/bonos/bono-posventa/components/disclaimers/bono-disclaimer-content';

const getHuchaDisclaimers = (personBenefits: PersonBenefits | null): string[] => {
	const huchaTier = getHuchaTierFromDiscounts(personBenefits?.benefits.discounts ?? []);

	if (huchaTier === 'renovador10To15') {
		return [HuchaDisclaimer1Text, HuchaDisclaimer2S10To15Text];
	}

	if (huchaTier === 'renovadorPlus15') {
		return [HuchaDisclaimer1Text, HuchaDisclaimer2Plus15Text];
	}

	return [HuchaDisclaimer1Text];
};

export const getAllDisclaimers = (
	personBenefits: PersonBenefits | null,
	vehicles: DataVehicles | null,
): NamedDisclaimer[] => {
	if (!vehicles || !personBenefits) return [];

	const normalizedVouchers = normalizeVouchers(personBenefits);

	const textToIndexMap = new Map();
	const disclaimers: NamedDisclaimer[] = [];
	let uniqueIndex = 1;

	let vouchersDisclaimers: string[] = [];
	let alertsDisclaimers: string[] = [];

	// add hucha disclaimers text
	const huchaDisclaimers = getHuchaDisclaimers(personBenefits);

	// add alerts disclaimers text
	if (noVehicleOrder2025(vehicles) && !voucherAlertExists(VouchersCampaign.IDWeChargePostPedido, normalizedVouchers)) {
		alertsDisclaimers.push(IdWeChargeDisclaimerText);
	}

	if (voucherAlertExists(VouchersCampaign.IDWeChargePostPedido, normalizedVouchers)) {
		alertsDisclaimers.push(IdWeChargeDisclaimerText);
	}

	// add bonus disclaimers text
	normalizedVouchers.forEach((voucher) => {
		if (!voucher.legalText?.trim()) return;

		const processedText = voucher.legalText
			.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
			.replace(/__(.*?)__/g, '<u>$1</u>');
		vouchersDisclaimers.push(processedText);
	});

	const allDisclaimersText: string[] = [
		...vouchersDisclaimers,
		...alertsDisclaimers,
		...huchaDisclaimers,
		BonoDisclaimerText,
	];

	allDisclaimersText.forEach((text) => {
		if (!textToIndexMap.has(text)) {
			textToIndexMap.set(text, uniqueIndex);
			disclaimers.push({
				ref: `${uniqueIndex}.`,
				text,
			});
			uniqueIndex++;
		}
	});

	return disclaimers;
};
